export default "__VITE_ASSET__Bw5TIap4__"